import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pageable, ResponseAPI } from '@models/response';
import { BankModel } from './n05.model';
import { Commission } from '../n12/n12.model';

@Injectable({
  providedIn: 'root'
})
export class N05Service {

  constructor(private http: HttpClient) {
  }

  // Cấu hình bank
  getListBank(page: number, size: number) {
    return this.http.get<ResponseAPI<Pageable<BankModel[]>>>(`/N05/banks?page=${page}&size=${size}`);
  }
  getCreateBank(bank) {
    return this.http.post<ResponseAPI<BankModel>>(`/N05/banks`, bank);
  }
  getUpdateBank(bank, id) {
    return this.http.put<ResponseAPI<BankModel>>(`/N05/banks/${id}`, bank);
  }
  getDeleteBank(id: number) {
    return this.http.delete<ResponseAPI<boolean>>('/N05/banks/' + id);
  }
  // get List Commission Config
  getListCommission() {
    return this.http.get<ResponseAPI<Commission[]>>(`/N052/list`);
  }
}
